import { useAppContext } from '@contexts/app';
import { useQueryParams } from '@hooks/queryParams';
import { SignIn } from './signIn';
import { parseRoute } from '@utils/i18n';
import { getUserData } from '@utils/getUserData';
import { PageLoader } from '@components/page/loader';
import { useGetUser } from '@services/resources/users/old/get';
import { useEffect, useRef } from 'react';
import { isNetworkError } from '@services/queryErrors';
import { QueryError } from '@components/queryError';
import { AccountLoadError } from '@components/accountLoadError';
import { reportAuthError } from '@services/auth/report';
import { useLogout } from '@hooks/useLogout';

export const DefaultView = () => {
  const {
    isLogged,
    admin: {
      isLogged: isAdminLogged,
      data: { homePage: adminHomePage },
    },
    homePage: userHomePage,
  } = useAppContext();

  const {
    params: { exchange },
  } = useQueryParams();
  const navigatedRef = useRef(false);
  const logout = useLogout();

  const localUserId = getUserData('user').id;
  const {
    error: userError,
    isLoading: isUserLoading,
    refetch: refetchUser,
  } = useGetUser(localUserId);

  const admin = isAdminLogged || Boolean(getUserData('admin').id);
  const user = isLogged || Boolean(localUserId);
  const rawHomePage = !user && admin ? adminHomePage : userHomePage;
  const homePage = parseRoute(`/${rawHomePage}`);
  const ready = (user || admin) && Boolean(rawHomePage);
  const userFailed = !isLogged && Boolean(userError) && !isUserLoading;
  const userUnreachable = userFailed && isNetworkError(userError);

  useEffect(() => {
    if (!ready || navigatedRef.current) return;
    navigatedRef.current = true;
    window.location.replace(homePage);
  }, [ready, homePage]);

  useEffect(() => {
    if (userFailed) reportAuthError('loadUser', userError);
  }, [userFailed, userError]);

  if (!user && !admin) return exchange ? <PageLoader /> : <SignIn />;
  if (userUnreachable && !admin) return <QueryError onRetry={() => void refetchUser()} />;
  if (userFailed && !admin)
    return (
      <AccountLoadError
        onRetry={() => void refetchUser()}
        onSignInAgain={() => logout('user', 'signInAgain')}
      />
    );
  return <PageLoader />;
};
